import { Badge } from "@/components/ui/badge";
import { Upload } from "lucide-react";

export default function UploadZone({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
  fileInputRef,
  onFileSelect,
  compact = false
}) {
  const acceptFormats = "image/*,.heic,.heif,.svg,.gif";

  if (compact) {
    return (
      <div
        data-testid="upload-zone-compact"
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onClick={onClick}
        className={`h-32 border-2 border-dashed rounded-lg cursor-pointer ${
          isDragging ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' : 'border-slate-300 dark:border-slate-600'
        } bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 flex flex-col items-center justify-center gap-2 transition-colors`}
      >
        <Upload className="w-6 h-6 text-blue-600 dark:text-blue-400" />
        <p className="text-sm text-slate-600 dark:text-slate-400">Add more images</p>
        <input
          ref={fileInputRef}
          type="file"
          accept={acceptFormats}
          multiple
          onChange={onFileSelect}
          className="hidden"
        />
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-5xl font-bold mb-4 tracking-tight text-slate-900 dark:text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Compress Your Images
        </h2>
        <p className="text-base md:text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
          Reduce file size without losing quality. All processing happens in your browser.
        </p>
      </div>

      <div
        data-testid="upload-zone"
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onClick={onClick}
        className={`upload-zone h-80 border-4 border-dashed rounded-xl cursor-pointer ${
          isDragging ? "drag-over border-blue-500" : "border-slate-300 dark:border-slate-600"
        } bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 flex flex-col items-center justify-center gap-4 transition-colors duration-300`}
      >
        <div className="w-20 h-20 rounded-full bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center">
          <Upload className="w-10 h-10 text-blue-600 dark:text-blue-400" />
        </div>
        <div className="text-center">
          <p className="text-xl font-semibold text-slate-900 dark:text-white mb-2">
            Drop, paste, or click to upload
          </p>
          <p className="text-sm text-slate-500 dark:text-slate-400">Ctrl+V to paste from clipboard • Multiple files supported</p>
        </div>
        <Badge variant="outline" className="text-xs dark:border-slate-600 dark:text-slate-300">JPEG, PNG, WebP, GIF, SVG, HEIC supported</Badge>
        <input
          ref={fileInputRef}
          type="file"
          accept={acceptFormats}
          multiple
          onChange={onFileSelect}
          className="hidden"
          data-testid="file-input"
        />
      </div>
    </div>
  );
}
